module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-03.8fa15d1f.jpg";